import ReactFinalForm from 'components/form/ReactFinalForm';
import { IMacroExam } from 'interfaces';
import { IdentityField } from 'components/form/IdentityField';
import { useTranslation } from 'react-i18next';
import { TextFieldAdapter } from 'components/form/TextFieldAdapter';
import { Field } from 'react-final-form';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';

interface MedicalServiceBaseInfoCreationFormParams {
  onSubmit: any;
  macroExams: IMacroExam[];
}

function MedicalServiceBaseInfoCreationForm(params: MedicalServiceBaseInfoCreationFormParams) {
  const translationPrefix = 'pages.medical-services-base-info.list';
  const { t } = useTranslation();

  const { onSubmit, macroExams } = params;

  return (
    <div>
      <ReactFinalForm onSubmit={onSubmit} formId="onSubmitCreateBaseInfo" hideControls>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="flex gap-5 w-full">
            <IdentityField
              name="macro_exam"
              component={AutocompleteAdapter}
              options={macroExams}
              label={t(`${translationPrefix}.entity.macro_exam`)}
              optionLabel="code"
              optionValue="id"
              required
            />
            <IdentityField
              name="caption"
              component={TextFieldAdapter}
              label={t(`${translationPrefix}.entity.caption`)}
              required
            />
          </div>
          <div className="w-full">
            <IdentityField
              name="sector"
              component={TextFieldAdapter}
              label={t(`${translationPrefix}.entity.sector`)}
              required
            />
          </div>
          <div className="flex gap-5 w-full">
            <div className="w-1/2">
              <IdentityField
                name="invoicing_code"
                component={TextFieldAdapter}
                label={t(`${translationPrefix}.entity.invoicing_code`)}
                required
              />
            </div>
            <div className="w-1/2">
              <IdentityField
                name="invoicing_code_description"
                component={TextFieldAdapter}
                label={t(`${translationPrefix}.entity.invoicing_code_description`)}
                required
              />
            </div>
          </div>
          <div className="w-1/2">
            <IdentityField
              name="asl_internal_codes"
              component={TextFieldAdapter}
              label={t(`${translationPrefix}.entity.asl_internal_codes`)}
            />
          </div>
          <div className="w-1/2">
            <IdentityField
              name="unit_price"
              component={TextFieldAdapter}
              label={t(`${translationPrefix}.entity.unit_price`)}
              type="number"
              initialValue={1}
              required
            />
          </div>
          <div className="">
            <Field name="attachment" required>
              {({ input: { value, onChange, ...input } }) => (
                <input
                  type="file"
                  onChange={({ target }) => onChange(target.files)}
                  style={{ marginBottom: '16px' }}
                  {...input}
                />
              )}
            </Field>
          </div>
        </div>
      </ReactFinalForm>
    </div>
  );
}

export default MedicalServiceBaseInfoCreationForm;
